import { NextPage } from 'next';
import DefaultLayout from '@components/_templates/DefaultLayout';
import styled from '@emotion/styled';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import FaqTopContent from '@components/_templates/faq/FaqTopContent';
import FaqQuestionAnswer from '@components/_templates/faq/FaqQuestionAnswer';
import FaqContentList from '@components/_templates/faq/FaqContentItem/list';
import { useEffect, useMemo, useState } from 'react';
import LinkText from '@components/_atoms/Link/LinkText';
import { FaqContentItemInfo } from '@components/_templates/faq/FaqContentItem';
import { CHANNEL_TALK, FIND } from '@constants/routes/routes';
import Typography from '@components/_atoms/Typography';
import { TypoVariant } from '@constants/atoms';

const FaqContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 110px 0;
  flex-direction: column;
  gap: 80px;
`;

export type FaqContentInfo = {
  readonly title: string;
  readonly faqContentItemInfoList: FaqContentItemInfo[];
};

const faqContentList: FaqContentInfo[] = [
  {
    title: '회원가입',
    // TODO : 추후 정책 추가되면 수정
    //questionList: ['기업 전용 아이디를 만들고 싶어요', '인증 이메일이 오지 않아요', '사업자등록증을 업로드하고 싶어요'],
    faqContentItemInfoList: [
      {
        title: '인증 이메일이 오지 않아요',
        content: [
          '1. 가입시 이메일 기입을 정확하게 했는지 확인해보세요',
          '2. 메일함에서 새로고침(F5) 한 후 확인해보세요',
          '3. 스팸함메일함을 꼭 확인해 보세요.',
          '4. 2,3분 정도 기다려도 안오는 경우, 재 발송을 요청해보세요.',
          <Typography variant={TypoVariant.B3} key={4} style={{ display: 'flex' }}>
            5. 위 방법이 안되는 경우&nbsp;
            <LinkText href={CHANNEL_TALK} fontSize={16}>
              상담원 연결
            </LinkText>
            을 통해 해결해 보세요.
          </Typography>,
        ],
        contentHtml:
          '1. 가입시 이메일 기입을 정확하게 했는지 확인해보세요2. 메일함에서 새로고침(F5) 한 후 확인해보세요3. 스팸함메일함을 꼭 확인해 보세요.4. 2,3분 정도 기다려도 안오는 경우, 재 발송을 요청해보세요.5. 위 방법이 안되는 경우 상담원 연결을 통해 해결해 보세요.',
      },
    ],
  },
  {
    title: '계정',
    faqContentItemInfoList: [
      {
        title: '아이디를 잊어버렸어요',
        content: [
          <Typography variant={TypoVariant.B3} key={0} style={{ display: 'flex' }}>
            💁🏻
            <LinkText href={CHANNEL_TALK} fontSize={16}>
              상담원 연결
            </LinkText>
            을 통해 빠르게 아이디를 찾아드립니다.
          </Typography>,
          '[양식]',
          '회원가입자 성함 : 성함을 적어주세요',
          '회사명 : 회사명을 적어주세요',
        ],
        contentHtml:
          '상담원 연결을 통해 빠르게 아이디를 찾아드립니다.[양식]회원가입자 성함 : 성함을 적어주세요회사명 : 회사명을 적어주세요',
      },
      {
        title: '비밀번호를 잊어버렸어요',
        content: [
          '비밀번호를 잊으신 경우, 이메일을 통해 재설정 하실 수 있습니다.',
          '아래 비밀번호 찾기 버튼을 클릭해주시면 해당 페이지로 넘어갑니다.',
          <LinkText href={`${FIND}?findType=Password`} key={3} fontSize={16}>
            비밀번호 찾기
          </LinkText>,
        ],
        contentHtml:
          '비밀번호를 잊으신 경우, 이메일을 통해 재설정 하실 수 있습니다.아래 비밀번호 찾기 버튼을 클릭해주시면 해당 페이지로 넘어갑니다.비밀번호 찾기',
      },
    ],
  },
  /* {
    title: '서비스',
    faqContentItemInfoList: [
      'steelboso 서비스가 궁금해요',
      'steelboso를 평가하고 싶어요',
      'steelboso의 뉴스레터를 받고 싶어요',
      '보유한 자재를 일괄 업로드하고 싶어요',
    ],
  }, */
  {
    title: '비즈니스',
    faqContentItemInfoList: [
      {
        title: '스틸보소에 투자하고 싶어요',
        content: [
          'No.1 스틸 중개거래 플랫폼 Steelboso를 관심 있게 봐주셔서 감사합니다.',
          '홈페이지 하단 이메일 문의나 아래 이메일로 궁금하신 사항 문의 바랍니다.',
          '[투자 관련 문의]',
          'support@steelboso.com',
        ],
        contentHtml:
          '[기업 인터뷰요청]support@steelboso.com저희 서비스에 관심을 가져주셔서 감사합니다.빠른 시일내에 회신 연락 드리겠습니다.',
      },
      {
        title: '스틸보소와 인터뷰하고 싶어요',
        content: [
          '[기업 인터뷰요청]',
          'support@steelboso.com',
          '저희 서비스에 관심을 가져주셔서 감사합니다.',
          '빠른 시일내에 회신 연락 드리겠습니다.',
        ],
        contentHtml:
          'No.1 스틸 중개거래 플랫폼 Steelboso를 관심 있게 봐주셔서 감사합니다.홈페이지 하단 이메일 문의나 아래 이메일로 궁금하신 사항 문의 바랍니다.[투자 관련 문의]support@steelboso.com',
      },
    ],
  },
];

const Faq: NextPage = () => {
  const [searchText, setSearchText] = useState<string>();
  const [activeCategoryIndex, setActiveCategoryIndex] = useState<number>(0);
  const [categoryList, setCategoryList] = useState<string[]>([]);

  useEffect(() => {
    setCategoryList(faqContentList.map((item) => item.title));
  }, []);

  const filteredFaqContentList = useMemo(
    () =>
      faqContentList
        .reduce<FaqContentInfo[]>(
          (result, item) =>
            searchText
              ? [
                  ...result,
                  {
                    ...item,
                    faqContentItemInfoList: item.title.includes(searchText)
                      ? item.faqContentItemInfoList
                      : item.faqContentItemInfoList.filter(
                          (info) =>
                            info.title.includes(searchText) ||
                            info.contentHtml.replace(/\s/g, '').includes(searchText.replace(/\s/g, '')),
                        ),
                  },
                ]
              : [...result, item],
          [],
        )
        .filter((item) => item.faqContentItemInfoList.length),
    [searchText],
  );

  useEffect(() => {
    setCategoryList((!searchText ? faqContentList : filteredFaqContentList).map((item) => item.title) || []);
  }, [searchText, filteredFaqContentList]);

  return (
    <>
      <DefaultLayout>
        <FaqContainer>
          <FaqTopContent
            categoryList={categoryList.length === 1 ? categoryList : ['전체', ...categoryList]}
            categoryIndex={activeCategoryIndex}
            handleSearchText={setSearchText}
            handleCategoryIndex={setActiveCategoryIndex}
          />

          {activeCategoryIndex === 0 && !searchText && <FaqQuestionAnswer />}

          <FaqContentList
            faqContentList={
              activeCategoryIndex && activeCategoryIndex !== 0
                ? [filteredFaqContentList[activeCategoryIndex - 1]]
                : filteredFaqContentList
            }
          />
        </FaqContainer>
      </DefaultLayout>
    </>
  );
};

export const getStaticProps = async ({ locale }: { locale: any }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['document', 'common', 'component'])),
  },
});

export default Faq;
